<script>
    import { ShieldAlert as ShieldAlertIcon } from 'lucide-svelte';
</script>

<footer
    class="bg-black-50 border-black-200 sticky bottom-0 z-30 cursor-default border-t px-4 py-2 text-xs shadow"
    id="frontendFooter">
    <div class="flex items-center justify-between">
        <p class="flex items-center gap-2">
            <ShieldAlertIcon class="shrink-0" size="16" />
            <span>Vertrauliche Informationen!</span>
        </p>
        <p>&copy; DWC</p>
    </div>
</footer>
